import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { Label, handleCustomStyles, selectTheme, TextMessage } from './styles';
import { SchemeToSelectFormat, SchemeFlieldsToSelectFormat } from 'src/utils/formatting';
import { Box } from 'rebass';


/* Componente encargado de parametrizar la regla SchemeAndFields */
/*
 * @param  {} options: opciones del esquema
 * @param  {} regla: objeto con los parametros de esa regla
 * @param  {} handleChangeSelect: handle para cambiar la seleccion
 * @param  {} error
 * @param  {} mError
 * @param  {} handleOnBlur
 */
const SchemeAndFields = ({
  options,
  regla,
  handleChangeSelect,
  error,
  mError,
  handleOnBlur
}) => {
  const { parameters } = regla;
  const optionsSchemas = SchemeToSelectFormat(options, 'esquema');
  const optionsCampos = parameters?.schema?.fields
    ? SchemeFlieldsToSelectFormat(parameters.schema.fields, 'campos')
    : [];
  let valuesMulti = [];
  if (typeof parameters.campos !== 'undefined' || parameters.campos !== '') {
    valuesMulti = parameters.campos;
  }
  return (
    <Row>
      <Col md={6} xs={12}>
        <Label>Esquema</Label>
        <Label required bold>*</Label>
        <Select
          onChange={(e) =>
            handleChangeSelect({ e, id: regla.id, dependentField: 'campos' })}
          options={optionsSchemas}
          placeholder='Seleccione un esquema'
          theme={selectTheme}
          value={
            typeof parameters.esquema === 'undefined' ||
              parameters.esquema === ''
              ? []
              : [{ value: parameters.esquema, label: parameters.esquema }]
          }
          styles={handleCustomStyles({ error: error?.esquema })}
          isDisabled={false}
          onBlur={handleOnBlur}
        />
        {error?.esquema ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
      <Col md={6} xs={12}>
        <Label>Campos</Label>
        <Label required bold>*</Label>
        <Select
          onChange={(e) =>
            handleChangeSelect({ e, id: regla.id, nameNull: 'campos' })}
          options={optionsCampos}
          placeholder='Seleccione los campos'
          theme={selectTheme}
          value={valuesMulti}
          isDisabled={false}
          styles={handleCustomStyles({ error: error?.campos })}
          isMulti
          onBlur={handleOnBlur}
        />
        {error?.campos ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
    </Row>
  );
};

export default SchemeAndFields;
